import React from 'react';
import { useHistory } from "react-router";
import { getBalanceSheet } from "api/urls";
import TableContainer from 'components/wrapper/TableContainer';


const BalanceSheet = (props) => {

    const history = useHistory()
    const unWantedKeys = ['as_on_date', 'created_at', 'updated_at', 'company_id', 'period', 'data_type', 'id', 'company']

    return (
        <div  {...props}>
            <TableContainer
                url={getBalanceSheet(history.location.search)}
                title={"Balance Sheet"}
                unWantedKeys={unWantedKeys}
            />
        </div>
    )
};

export default (BalanceSheet);
